import { render, staticRenderFns } from "./selecionar-beneficiario.vue?vue&type=template&id=2822e864&scoped=true"
import script from "./selecionar-beneficiario.vue?vue&type=script&lang=js"
export * from "./selecionar-beneficiario.vue?vue&type=script&lang=js"
import style0 from "./selecionar-beneficiario.vue?vue&type=style&index=0&id=2822e864&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2822e864",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VDataTable,
  VFlex,
  VLayout,
  VTextField,
})
